import { render, staticRenderFns } from "./dashboard-terra.vue?vue&type=template&id=274a8880"
import script from "./dashboard-terra.vue?vue&type=script&lang=js"
export * from "./dashboard-terra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports